// YouTube Modal Player Handler
class YouTubeModalPlayer {
    constructor(blockId) {
      this.blockId = blockId;
      this.player = null;
      this.playerState = {
        isAPIReady: false,
        isPlayerReady: false,
        errors: []
      };
      
      this.init();
    }
  
    init() {
      // Load YouTube API
      if (!window.YT) {
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      }
  
      // Define the global callback
      window.onYouTubeIframeAPIReady = () => this.onYouTubeIframeAPIReady();
      
      // Setup DOM ready handlers
      document.addEventListener('DOMContentLoaded', () => this.setupModalObserver());
    }
  
    onYouTubeIframeAPIReady() {
      console.log('YouTube API is ready');
      this.playerState.isAPIReady = true;
  
      try {
        this.player = new YT.Player(`youtube-player-${this.blockId}`, {
          events: {
            onReady: (event) => this.onPlayerReady(event),
            onStateChange: (event) => this.onPlayerStateChange(event),
            onError: (event) => this.onPlayerError(event)
          },
          playerVars: {
            autoplay: 0, // Disable autoplay by default
            enablejsapi: 1,
            rel: 0
          }
        });
      } catch (error) {
        console.error('Player initialization failed:', error);
        this.playerState.errors.push(error);
      }
    }
  
    onPlayerReady(event) {
      this.playerState.isPlayerReady = true;
      this.setupEventListeners();
    }
  
    setupEventListeners() {
      const modal = document.querySelector(`#PopupModal-${this.blockId}`);
      const closeButton = document.querySelector(`#ModalClose-${this.blockId}`);
  
      if (closeButton) {
        closeButton.addEventListener('click', () => this.stopVideo());
      }
  
      if (modal) {
        modal.addEventListener('click', (e) => {
          if (e.target === modal) this.stopVideo();
        });
      }
    }
  
    stopVideo() {
      if (this.player && this.player.stopVideo) {
        this.player.stopVideo();
      }
    }
  
    onPlayerStateChange(event) {
      const states = {
        '-1': 'unstarted',
        '0': 'ended',
        '1': 'playing',
        '2': 'paused',
        '3': 'buffering',
        '5': 'video cued'
      };
      console.log('Player state:', states[event.data]);
    }
  
    onPlayerError(event) {
      const errors = {
        2: 'Invalid parameter',
        5: 'HTML5 player error',
        100: 'Video not found',
        101: 'Embedding not allowed',
        150: 'Embedding not allowed'
      };
      console.error('Player error:', errors[event.data] || 'Unknown error');
    }
  
    setupModalObserver() {
      const modal = document.querySelector(`#PopupModal-${this.blockId}`);
      
      if (modal) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === 'open') {
              const isOpen = modal.hasAttribute('open');
              if (isOpen && this.player && this.player.playVideo) {
                this.player.playVideo();
              } else if (!isOpen && this.player && this.player.stopVideo) {
                this.player.stopVideo();
              }
            }
          });
        });
  
        observer.observe(modal, { attributes: true });
      }
    }
  }
  
  // Make available globally
  window.YouTubeModalPlayer = YouTubeModalPlayer;